import React from "react";
import { bankCodeWriting } from '$Deposits/lib/LibCommonData'
import UserBankSelectCon from '$Deposits/Components/Components/UserBankSelect'
import { Select, Input, Form, Icon } from "antd";
const { Option } = Select;
const { Item } = Form;
class UserBankSelect extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };

    }

    componentDidUpdate(prevProps, prevState) {

    }
    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {



        return (
            <>
                <UserBankSelectCon
                    UserBankSelect={(propCon) => {
                        const {
                            onChange,
                            DepositMemberBanksActive,
                            BankList,
                            AddBankClick,
                            methods
                        } = propCon
                        return (
                            <BankDrawer
                                onChange={onChange}
                                DepositMemberBanksActive={DepositMemberBanksActive}
                                BankList={BankList}
                                AddBankClick={AddBankClick}
                                methods={methods}
                            />
                        )
                    }}

                />



            </>
        );
    }
}

export default UserBankSelect

export class BankDrawer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        };

    }
    render() {

        const {
            onChange,
            DepositMemberBanksActive,
            BankList,
            AddBankClick,
        } = this.props;

        const { code } = DepositMemberBanksActive || {}
        return (
            <>
                {
                    BankList.length > 0 &&
                    <Item className="UserBankSelect" label={'Tài Khoản Của Bạn'}>
                        <div className="drop-area">
                            <Select
                                onSelect={() => this.setState({open: true})}
                                size="large"
                                value={code}
                                onChange={(v) => {
                                    if(v === "addBankCard") return
                                    const bank = BankList.find((item) => { return item.code == v })
                                    onChange(bank)
                                }}
                                getPopupContainer={() =>
                                    document.querySelector(".drop-area")
                                }
                                suffixIcon={
                                    <Icon type={"caret-down"} />
                                }
                                // disabled={BankList.length == 1}
                            >
                                {BankList.map((value, index) => {
                                    return (
                                        <Option
                                            value={value.code}
                                            key={value.code + index}
                                        >
                                            <span className={'bankIcon-default bankIcon-' + bankCodeWriting(value.bankNameEn)} />
                                            <p className="inputViewName">{value.bankNameEn + " " + value.accountNumber.replace(/.(?=.{3})/g, "*")}</p>
                                            {/* <span className="drawerIcon" /> */}
                                        </Option>
                                    );
                                })}
                                <Option key={"addBankCard"} className="addBank" data-CN="新增銀行帳戶" onClick={() => { AddBankClick() }}>
                                    <span>Thêm Tài Khoản Nhân Hàng</span>
                                    <span> +</span>
                                </Option>
                            </Select>
                        </div>
                    </Item>
                }
                {
                    BankList.length == 0 &&
                    <Item label={'Tài Khoản Của Bạn'}>
                        <div
                            className="liveChatBtn"
                            data-CN="新增銀行帳號"
                            onClick={() => {
                                AddBankClick()
                            }}
                        >
                            Thêm Tài Khoản Nhân Hàng
                        </div>
                    </Item>
                }
            </>
        )
    }
}

